import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const addExtraApproversAPI = createApi(`AddExtraApproversSlice`,"PUT");

const AddExtraApproversSlice = createSlice({
  name: 'AddExtraApproversSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addExtraApproversAPI.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addExtraApproversAPI.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(addExtraApproversAPI.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default AddExtraApproversSlice.reducer;